import { render, staticRenderFns } from "./ProductosyServicios.vue?vue&type=template&id=18c98db2&"
import script from "./ProductosyServicios.vue?vue&type=script&lang=js&"
export * from "./ProductosyServicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports